import { render, staticRenderFns } from "./apiScript.vue?vue&type=template&id=4542beef"
import script from "./apiScript.vue?vue&type=script&lang=js"
export * from "./apiScript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports